import React from "react";
import WaveText from "../WaveText";

export default function TrueFalseGeneratorPanel({
  showTrueFalseGenerator, generatedTrueFalse, showAskMe, showTemplates,
  showWordDefinitionGenerator, showWordTranslationGenerator, showWarmUpDiscussionGenerator,
  showCreateDialogueGenerator, showEssentialVocabularyGenerator, showLeadInActivitiesGenerator,
  showFourOpinionsGenerator, showCommunicativeSituationsGenerator, showGrammarRulesGenerator,
  trueFalseInput, setTrueFalseInput, trueFalseLevel, setTrueFalseLevel,
  trueFalseCount, setTrueFalseCount, trueFalseLoading,
  handleTrueFalseGenerate, handleTrueFalseInsert, handleTrueFalseCancel,
}) {
  if (!((showTrueFalseGenerator || generatedTrueFalse) && !showAskMe && !showTemplates && !showWordDefinitionGenerator && !showWordTranslationGenerator && !showWarmUpDiscussionGenerator && !showCreateDialogueGenerator && !showEssentialVocabularyGenerator && !showLeadInActivitiesGenerator && !showFourOpinionsGenerator && !showCommunicativeSituationsGenerator && !showGrammarRulesGenerator)) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, transition: 'opacity 0.22s, transform 0.22s' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button onClick={handleTrueFalseCancel} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginRight: 4, transition: 'color 0.18s' }}>
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M12 16l-4-4 4-4" stroke="#8a2be2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <span style={{ fontSize: 16, fontWeight: 600, color: '#22223b' }}>Generate True/False Statements</span>
      </div>

      <textarea
        value={trueFalseInput}
        onChange={e => setTrueFalseInput(e.target.value)}
        placeholder="Paste your text here, based on which we'll generate statements"
        rows={4}
        style={{
          fontSize: 15,
          padding: '12px',
          borderRadius: 8,
          border: '1.5px solid #cfcfff',
          background: '#f7fbff',
          resize: 'vertical',
          fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
          width: '100%',
          boxSizing: 'border-box'
        }}
      />

      <div style={{ display: 'flex', gap: 12, marginBottom: 8, alignItems: 'center' }}>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 6 }}>
          CEFR Level:
          <select
            value={trueFalseLevel}
            onChange={e => setTrueFalseLevel(e.target.value)}
            style={{
              fontSize: 14,
              padding: '6px 8px',
              borderRadius: 6,
              border: '1.5px solid #cfcfff',
              background: '#fff',
              cursor: 'pointer',
              width: 100
            }}
          >
            <option value="A1">A1</option>
            <option value="A2">A2</option>
            <option value="B1">B1</option>
            <option value="B2">B2</option>
            <option value="C1">C1</option>
            <option value="C2">C2</option>
          </select>
        </label>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 6 }}>
          Statements:
          <input
            type="number"
            min={1}
            max={10}
            value={trueFalseCount}
            onChange={e => setTrueFalseCount(e.target.value)}
            onBlur={e => setTrueFalseCount(Math.max(1, Math.min(10, Number(e.target.value) || 1)))}
            title="1–10 statements"
            style={{
              fontSize: 14,
              padding: '6px 8px',
              borderRadius: 6,
              border: '1.5px solid #cfcfff',
              background: '#fff',
              width: 60
            }}
          />
          <span style={{ fontSize: 12, color: '#8f8fb0', fontWeight: 400, whiteSpace: 'nowrap' }}>max 10</span>
        </label>
      </div>

      <button
        onClick={handleTrueFalseGenerate}
        disabled={trueFalseLoading || !trueFalseInput.trim()}
        className={trueFalseLoading ? 'magic-generating-btn' : 'magic-btn'}
        style={{
          fontSize: 15,
          padding: '12px 16px',
          borderRadius: 8,
          border: 'none',
          background: trueFalseLoading || !trueFalseInput.trim() ? '#e0e0e0' : '#8a2be2',
          color: trueFalseLoading || !trueFalseInput.trim() ? '#999' : '#fff',
          fontWeight: 600,
          cursor: trueFalseLoading || !trueFalseInput.trim() ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s'
        }}
      >
        {trueFalseLoading ? <WaveText /> : 'Do the magic'}
      </button>

      {(() => {
        return generatedTrueFalse && generatedTrueFalse.statements && Array.isArray(generatedTrueFalse.statements) ? (
          <div style={{ marginTop: 12, padding: 12, background: '#f8f9fa', borderRadius: 8, border: '1px solid #e9ecef' }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#22223b', marginBottom: 8 }}>
              Generated: True/False Exercise
            </div>
            <div style={{ fontSize: 13, color: '#6c757d', marginBottom: 12 }}>
              {generatedTrueFalse.statements.length} statements ready
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={handleTrueFalseInsert}
              className="magic-btn"
              style={{ fontSize: 14, padding: '8px 16px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', width: '100%' }}
            >
              Add
            </button>
          </div>
          </div>
        ) : null;
      })()}
    </div>
  );
}
